import { Settings } from '../typings/settings';
import api from './baseApi';

export const getSettings = async (store: string): Promise<Settings> => {
    const response = await api.get('settings/private', {
        params: {
            shop: store
        }
    });
    return response.data;
};
